import { Link } from "react-router-dom";

const StatusColumn = ({ status }) => {
    const statusLabels = {
        ACTIVE: "Ativo",
        DRAFT: "Rascunho",
        CLOSED: "Encerrado",
        CANCELED: "Cancelado",
    };

    const statusClass = status ? status.toLowerCase() : "draft";

    return (
        <div className={`status-pill ${statusClass}`}>
            {statusLabels[status] || status}
        </div>
    );
};

const EventsListCards_Card = ({ item }) => {
    return (
        <div className="col-12 col-md-6 col-lg-4 mb-4" key={item.id}>
            <div className="block-cards h-100 d-flex flex-column">
                <div className="block-cards-header">
                    <span className="text-uppercase small fw-bold text-muted">
                        {item.date_formated}
                    </span>
                    <StatusColumn status={item.status} />
                </div>

                <div className="block-cards-body flex-grow-1">
                    <div className="block-cards-body-image mb-3">
                        <img src={item.image} alt={item.name} />
                    </div>

                    <h3 className="event-name-title">{item.name}</h3>

                    <div className="event-stats-container">
                        <div className="event-stat-item">
                            <div className="stats-title">Views</div>
                            <div className="stats-value">{item.stats.view}</div>
                        </div>
                        <div className="event-stat-item">
                            <div className="stats-title">Clicks</div>
                            <div className="stats-value">{item.stats.click}</div>
                        </div>
                    </div>

                    <div className="d-grid gap-2 mt-auto">
                        <a
                            href={`https://nightspotapp.com/v/${item.venue_slug}`}
                            target="_blank"
                            className="btn btn-event-action btn-public-link"
                            rel="noreferrer"
                        >
                            <i className="fa-solid fa-arrow-up-right-from-square me-2"></i>
                            Página do Evento
                        </a>

                        <div className="d-flex gap-2">
                            {item.status !== "CLOSED" && item.status !== "CANCELED" && (
                                <Link
                                    to={`/my/events/update/${item.id}`}
                                    className="btn btn-event-action btn-manage flex-grow-1 text-center"
                                >
                                    <i className="fa-solid fa-gears me-2"></i>
                                    Gerir
                                </Link>
                            )}
                            <Link
                                to={`/my/events/${item.id}/stats/`}
                                state={{ item }}
                                className="btn btn-event-action btn-stats flex-grow-1 text-center"
                            >
                                <i className="fa-solid fa-chart-line me-2"></i>
                                Stats
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EventsListCards_Card;